import type { MemberSessionSummary } from '@aeris/contracts'

/**
 * De onde a sessão é, na Equipe → Sessões: o celular pelo nome do aparelho
 * (F304), e o IP quando há.
 *
 * O nome é o que o próprio celular diz — rótulo para reconhecer, não prova.
 */
export const sessionOrigin = (
  session: Pick<MemberSessionSummary, 'clientKind' | 'deviceName' | 'ip'>
): string => {
  const device =
    session.clientKind === 'mobile'
      ? session.deviceName === null
        ? 'Celular'
        : `Celular — ${session.deviceName}`
      : null
  if (device === null) return session.ip ?? '—'
  return session.ip === null ? device : `${device} · ${session.ip}`
}
